// components/ItemsForm.js
import React, { useState } from 'react';
import { Plus, Minus, Package, Settings } from 'lucide-react';
import { formatNumber } from '../utils/formatters';
import ProductSelector from './ProductSelector';
import ProductManager from './ProductManager';

const ItemsForm = ({ items, onAddItem, onRemoveItem, onUpdateItem }) => {
  const [showProductManager, setShowProductManager] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState({}); // 각 아이템별 선택된 제품 저장
  
  const handleProductSelect = (itemId, product) => {
    if (product) {
      // 품목 선택 시
      setSelectedProducts(prev => ({ ...prev, [itemId]: product }));
      onUpdateItem(itemId, 'description', product.name);
      onUpdateItem(itemId, 'unitPrice', product.unitPrice);
      
      const currentItem = items.find(item => item.id === itemId);
      const currentQuantity = currentItem?.quantity || 1;
      
      // 품목 선택 시 수량이 없으면 1로 설정
      if (!currentQuantity || currentQuantity === 0) {
        onUpdateItem(itemId, 'quantity', 1);
      } else {
        // 이미 수량이 있으면 금액 재계산을 위해 수량을 다시 설정
        onUpdateItem(itemId, 'quantity', currentQuantity);
      }
    } else {
      // 품목 선택 해제 시 (검색창을 지울 때)
      setSelectedProducts(prev => ({ ...prev, [itemId]: null }));
      onUpdateItem(itemId, 'description', '');
      onUpdateItem(itemId, 'unitPrice', 0);
      onUpdateItem(itemId, 'quantity', 0);
    }
  };
  return (
    <div className="md:mb-4 lg:mb-10">
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-sm font-medium flex items-center">

          품목 정보
        </h3>
        <div className="flex gap-2">
          <button
            onClick={() => setShowProductManager(true)}
            className="bg-gray-100 hover:bg-gray-200 border border-gray-300 px-3 py-1 rounded-md text-sm flex items-center gap-1 transition-colors"
          >
            <Settings className="w-4 h-4" />
            품목 관리
          </button>
          <button
            onClick={onAddItem}
            className="bg-blue-500 text-white px-3 py-1 rounded-md hover:bg-blue-600 flex items-center text-sm transition-colors"
          >
            <Plus className="w-4 h-4 mr-1" />
            품목 추가
          </button>
        </div>
      </div>
      
      <div className="space-y-4">
        {items.map((item) => (
          <div key={item.id} className="bg-gray-50 rounded-lg p-1">
            <div className="grid grid-cols-1 md:grid-cols-11 gap-3 items-center">
              {/* 품목 선택 */}
              <div className="col-span-1 md:col-span-5">
                <label className="block text-xs font-medium text-gray-700 mb-1">품목</label>
                <ProductSelector
                  onSelectProduct={(product) => handleProductSelect(item.id, product)}
                  selectedProduct={selectedProducts[item.id] || null}
                  placeholder="품목 선택 또는 입력..."
                />
              </div>
              
              {/* 단가 */}
              <div className="col-span-1 md:col-span-2">
                <label className="block text-xs font-medium text-gray-700 mb-1">단가</label>
                <input
                  type="number"
                  placeholder="0"
                  value={item.unitPrice || ''}
                  onChange={(e) => onUpdateItem(item.id, 'unitPrice', parseFloat(e.target.value) || 0)}
                  className="w-full border border-gray-300 rounded-md px-2 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              
              {/* 수량 */}
              <div className="col-span-1 md:col-span-1">
                <label className="block text-xs font-medium text-gray-700 mb-1">수량</label>
                <input
                  type="number"
                  placeholder="1"
                  value={item.quantity || ''}
                  onChange={(e) => onUpdateItem(item.id, 'quantity', parseFloat(e.target.value) || 0)}
                  className="w-full border border-gray-300 rounded-md px-2 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              
              {/* 금액 */}
              <div className="col-span-1 md:col-span-2">
                <label className="block text-xs font-medium text-gray-700 mb-1">금액</label>
                <div className="bg-white border border-gray-200 rounded-md px-2 py-2 text-sm font-medium text-gray-900 text-right">
                  {formatNumber(item.amount)}원
                </div>
              </div>
              
              {/* 삭제 버튼 */}
              <div className="col-span-1 md:col-span-1 flex justify-center">
                <button
                  onClick={() => onRemoveItem(item.id)}
                  className="text-red-500 hover:text-red-700 hover:bg-red-50 p-2 rounded-md transition-colors"
                  disabled={items.length === 1}
                  title="품목 삭제"
                >
                  <Minus className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* 품목 관리 모달 */}
      {showProductManager && (
        <ProductManager onClose={() => setShowProductManager(false)} />
      )}
    </div>
  );
};

export default ItemsForm;